import { createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL from "../../config";

export const fetchClasses = createAsyncThunk(
  "class/fetchClasses",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/classes/all`);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch classes");
      }
      const data = await response.json();
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const createClassThunk = createAsyncThunk(
  "class/createClass",
  async (classData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/classes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(classData),
      });
      if (!response.ok) throw await response.json();
      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message || "Failed to create class");
    }
  }
);

export const updateClassThunk = createAsyncThunk(
  "class/updateClass",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/classes/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw await response.json();
      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message || "Failed to update class");
    }
  }
);
export const deleteClassThunk = createAsyncThunk(
  "class/deleteClass",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/classes/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error((await response.json()).message);
      return id;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const publishClassThunk = createAsyncThunk(
  "class/publishClass",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/classes/publish/${id}`, {
        method: "PUT",
      });
      if (!response.ok) throw new Error((await response.json()).message);
      return id;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const saveLinkedSubjectsThunk = createAsyncThunk(
  "class/saveLinkedSubjects",
  async ({ class_id, class_name, subject_ids }, { rejectWithValue }) => {
    try {
      const payload = {
        class_id,
        class_name,
        subject_ids,
        status: 1,
      };

      const res = await fetch(`${API_BASE_URL}/classes/${class_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.message || "Failed to update class.");
      }

      return true;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const fetchLinkedSubjectsThunk = createAsyncThunk(
  "class/fetchLinkedSubjects",
  async (classId, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE_URL}/subjects/link/${classId}`);
      if (!res.ok) throw new Error("Failed to fetch linked subjects");
      const data = await res.json();
      return data.map((sub) => sub.subject_id);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
